import { IMicroConfiguration } from '../types/configuration';
import { Micro } from './micro';

import { View, IView } from'../../../pip/library/pi-interop/pi-interop.js';
import f1 from'../../../pip/library/pi-f1/pi-f1.js';

export class MicroView extends View implements IView {
  private __configuration: IMicroConfiguration;
  private __micro: Micro<IMicroConfiguration>;

  constructor(micro: Micro<IMicroConfiguration>) {
    super();
    this.__micro = micro;
  }

  initialize(configuration: IMicroConfiguration) {
    // @note we cannot allow the top-level route to have a /* or it will eat all routes
    f1.write('/routes/uri', f1.replace('/*', '', f1.read('/routes/uri', '', configuration)), configuration);

    this.__configuration = configuration;
    return f1.done(this);
  }

  /**
   *
   */
  async mount(region: HTMLElement) {
    // @note we need this because we mount on to the micro
    //
    this.region = region;
    await this.__micro.startup(region, this.__configuration);
    return this;
  }

  /**
   *
   */
  async unmount() {
    await this.__micro.shutdown();
    return this;
  }
}
